/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { AddCircle, AttachFile, CloudUpload, Send } from "@mui/icons-material";
import { Box, Button, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Paper, Select, SelectChangeEvent, TextField, Typography } from "@mui/material"
import { FormEvent, useEffect, useState } from "react"
import SelectAnalises from "../SelectAnalises";
import { createSolicitacao, getSolicitacaoById, getSolicitacoes, Solicitacao, updateSolicitacao } from "../../services/solicitacoesService";
import { v4 as uuidv4 } from 'uuid';
import * as Yup from 'yup';
import ModalEnvio from "../ModalEnvio";
import { useParams } from "react-router-dom";
import CircularIndeterminate from "../CircularProgress";
import { getProjetos, Projeto } from "../../services/projetosService";
import { fetchAuthSession, fetchUserAttributes } from "aws-amplify/auth"
import { getMateriais, Material } from "../../services/materiaisService";
import { Analise, getAnalises } from "../../services/analisesService";
import { uploadData } from "aws-amplify/storage";
import axios from "axios";

const validationSchema = Yup.object().shape({
    nome: Yup.string().required('Nome é obrigatório'),
    email: Yup.string().email('Email inválido').required('Email é obrigatório'),
    setor: Yup.string().required('Setor é obrigatório'),
    projeto: Yup.string().required('Projeto é obrigatório'),
    data_solicitacao: Yup.date().required('Data de solicitação é obrigatória'),
    objetivo: Yup.string().required('Objetivo é obrigatório'),
    destino: Yup.string().required('Destino pós-teste é obrigatório'),
    observacoes: Yup.string().notRequired(),
    amostras: Yup.array().of(Yup.object().shape({
        id_amostra: Yup.string().required('ID da amostra é obrigatório'),
        material: Yup.string().required('Material é obrigatório'),
        analise: Yup.array().of(Yup.string()).required('Análise é obrigatória'),
        preparo: Yup.string().required('Preparo é obrigatório')
    })).required('Amostras são obrigatórias').min(1, 'Pelo menos uma amostra é obrigatória')
});

export default function Formulario() {
    const { id } = useParams<{ id: string }>(); // Obtendo o ID da solicitação da URL

    const [isEditing, setIsEditing] = useState(false)
    const [outrosSelecionados, setOutrosSelecionados] = useState<boolean[]>([]);
    const [outrasSelecionadas, setOutrasSelecionadas] = useState<boolean[]>([]);
    const [isOutroProjeto, setIsOutroProjeto] = useState(false)
    const [showThankYouScreen, setShowThankYouScreen] = useState(false);
    const [nSolicitacao, setNSolicitacao] = useState<string>('');
    const [userName, setUserName] = useState<string>('')
    const [loading, setLoading] = useState(true)
    const [loadingButton, setLoadingButton] = useState(false)
    const [projetos, setProjetos] = useState<Projeto[]>([])
    const [materiais, setMateriais] = useState<Material[]>([])
    const [analises, setAnalises] = useState<string[]>([])
    const [file, setFile] = useState<File | null>(null)

    const getCurrentDate = () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
    
        return `${yyyy}-${mm}-${dd}`;
    };

    const [samples, setSamples] = useState<{ id: number; id_amostra: string; material: string; analise: string[]; preparo: string }[]>([
        { id: 1, id_amostra: '', material: '', analise: [], preparo: '' }
    ]);
    
    const [formData, setFormData] = useState({
        nome: "",
        email: "",
        setor: "",
        data_solicitacao: getCurrentDate(),
        objetivo: "",
        projeto: "",
        destino: "",
        observacoes: ""
    });

    useEffect(() => {
        const loadSolicitacao = async () => {
            setLoading(true);
            try {
                if (id) {
                    const solicitacao = await getSolicitacaoById(id);
    
                    if (solicitacao) {
                        let amostrasArray;
    
                        if (typeof solicitacao.amostras === 'string') {
                            amostrasArray = JSON.parse(solicitacao.amostras) || [];
                        } else {
                            amostrasArray = solicitacao.amostras || [];
                        }
    
                        setFormData({
                            nome: solicitacao.nome,
                            email: solicitacao.email,
                            setor: solicitacao.setor,
                            data_solicitacao: solicitacao.data_solicitacao,
                            objetivo: solicitacao.objetivo,
                            projeto: solicitacao.projeto,
                            destino: solicitacao.destino,
                            observacoes: solicitacao.observacoes
                        });
    
                        setSamples(amostrasArray);
                        setNSolicitacao(solicitacao.n_solicitacao);
                        setIsEditing(true);
                    } else {
                        console.warn("Solicitação não encontrada.");
                    }
                } else {
                    // Carregar dados do usuário autenticado se não houver ID
                    const user = await fetchUserAttributes();
    
                    // Acessar corretamente os atributos do usuário
                    const attributes = user as any; // Se necessário, ajuste a tipagem
    
                    setFormData({
                        nome: attributes['custom:display_name']|| "",
                        email: attributes.email || "",
                        setor: attributes["custom:setor"] || "",
                        data_solicitacao: getCurrentDate(),
                        objetivo: "",
                        projeto: "",
                        destino: "",
                        observacoes: ""
                    });
                }
            } catch (error) {
                console.error("Erro ao carregar solicitação ou dados do usuário:", error);
            } finally {
                setLoading(false);
            }
        };
    
        const loadProjetos = async () => {
            setLoading(true);
            try {
                const listaProjetos = await getProjetos();
                setProjetos(listaProjetos);
            } catch (error) {
                console.error('Erro ao carregar projetos:', error);
            } finally {
                setLoading(false);
            }
        };

        const loadMateriais = async () => {
            setLoading(true)
            try {
                const listaMateriais = await getMateriais()
                setMateriais(listaMateriais)
            } catch (error) {
                console.error('Erro ao carregar os materiais')
            } finally {
                setLoading(false)
            }
        }

        const loadAnalises = async () => {
            setLoading(true)
            try {
                const listaAnalises: Analise[] = await getAnalises()
                const nomesAnalises = listaAnalises.map((analise) => analise.nome);
                setAnalises(nomesAnalises)
            } catch (error) {
                console.error('Erro ao carregar as análises')
            } finally {
                setLoading(false)
            }
        }
    
        if (id) {
            loadSolicitacao();
        } else {
            loadSolicitacao();
        }
    
        loadProjetos();
        loadMateriais();
        loadAnalises()
        //console.log(file);
    }, [id]);
    
    const [errors, setErrors] = useState<any>({});
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleProjetoChange = (event: { target: { value: any; }; }) => {
        const value = event.target.value
        
        if (value === "Outro") {
            setIsOutroProjeto(true)
            setFormData({ ...formData, projeto: "" })
        } else {
            setIsOutroProjeto(false)
            setFormData({ ...formData, projeto: value })
        }
    }
    const handleProjetoTextChange = (event: { target: { value: any; }; }) => {
        setFormData({ ...formData, projeto: event.target.value })
    }

    const handleAddSample = () => {
        if (samples.length < 50) {
          setSamples([...samples, { id: samples.length + 1, id_amostra: '', material: '', analise: [], preparo: '' }]);
        }
      };
    
    const handleRemoveSample = (index: number) => {
        setSamples(samples.filter((_, i) => i !== index));
    };

    const generateNSolicitacao = async (): Promise<string> => {
        const year = new Date().getFullYear().toString().slice(-2);
        const solicitacoes = await getSolicitacoes();
        
        // Filtra as solicitações que pertencem ao ano atual
        const solicitacoesDoAno = solicitacoes.filter(s => s.n_solicitacao.startsWith(`LQI${year}-`));
        
        // Encontra o maior número sequencial para o ano atual
        const ultimoNumero = solicitacoesDoAno.reduce((max, s) => {
            const partes = s.n_solicitacao.split('-');
            if (partes.length === 2) {
                const num = parseInt(partes[1]);
                return !isNaN(num) && num > max ? num : max;
            }
            return max;
        }, 0);

        const nextCount = ultimoNumero + 1;
        return `LQI${year}-${String(nextCount).padStart(3, '0')}`;
    };

    const handleChangeFile = (event: any) => {
        setFile(event.target.files[0])
    }

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        
        // Evita disparos múltiplos se já estiver carregando
        if (loadingButton) return;
    
        try {
            await validationSchema.validate({
                ...formData,
                amostras: samples
            }, { abortEarly: false });
        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors: any = {};
                err.inner.forEach((error: Yup.ValidationError) => {
                    validationErrors[error.path!] = error.message;
                });
                setErrors(validationErrors);
                return;
            }
        }
    
        setErrors({});
    
        let nSolicitacao: string;
    
        if (isEditing) {
            if (!id) {
                console.error("ID não está definido.");
                return;
            }
    
            const existingSolicitacao = await getSolicitacaoById(id);
            if (existingSolicitacao) {
                nSolicitacao = existingSolicitacao.n_solicitacao;
            } else {
                console.error("Solicitação não encontrada para atualização.");
                return;
            }
        } else {
            nSolicitacao = await generateNSolicitacao();
        }
    
        setNSolicitacao(nSolicitacao);
    
        let fileUrl = '';
        if (file) {
            // Sanitização silenciosa: remove acentos e troca espaços por underline
            const safeName = file.name
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/\s+/g, '_')
                .replace(/[^\w.-]/g, '');

            const result = await uploadData({
                path: `anexos/${safeName}`,
                data: file
            }).result;
            console.log('Arquivo enviado com sucesso', result);
            fileUrl = result.path || `anexos/${safeName}`;
        }
    
        const solicitacao: Solicitacao = {
            id: id || uuidv4(),
            n_solicitacao: nSolicitacao,
            ...formData,
            amostras: JSON.stringify(samples.map(sample => ({
                id_amostra: sample.id_amostra,
                material: sample.material,
                analise: sample.analise,
                preparo: sample.preparo
            }))),
            arquivo_anexo: fileUrl,
            arquivo_aditivo: '',
            arquivo_relatorio: '',
            status: 1,
            data_aprovacao: "",
            data_relatorio: "",
            data_pesquisa: "",
            data_conclusao: "",
            nota: 0,
            feedback: "",
            motivo_rejeicao: ""
        };
    
        try {
            setLoadingButton(true);
    
            let response;
            if (isEditing) {
                response = await updateSolicitacao(solicitacao);
            } else {
                response = await createSolicitacao(solicitacao);
            }
    
            // Enviar e-mail após a criação/atualização
            const emailData = {
                subject: `Solicitação ${isEditing ? 'atualizada' : 'criada'}: ${nSolicitacao}`,
                body: `
                A solicitação ${nSolicitacao} foi ${isEditing ? 'atualizada' : 'criada'} por ${solicitacao.nome}! 
                Acesse a plataforma para mais informações!`,
                recipient: 'naiara.leite@itemm.org.br', 
            };
            
            try {
                const session = await fetchAuthSession()
                const token = session.tokens?.idToken
                const emailResponse = await axios.post('https://5n2t581gd4.execute-api.us-east-2.amazonaws.com/prod', emailData, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                });
                console.log('E-mail enviado:', emailResponse.data);
            } catch (error) {
                console.error('Erro ao enviar e-mail:', error);
            }            

            setSubmitted(true);
            setShowThankYouScreen(true);
            setTimeout(() => {
                setShowThankYouScreen(false);
                window.location.href = "/minhassolicitacoes";
            }, 5000);
        } catch (error) {
            console.error("Erro ao salvar solicitação:", error);
        } finally {
            setLoadingButton(false);
        }
    };
        
    return(
        <>
            {showThankYouScreen && (<ModalEnvio n_solicitacao={nSolicitacao} />)}
            <Paper elevation={3} style={{ padding: '20px', margin: '20px', minHeight: 'calc(100vh - 250px)' }}>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h6">Dados do Solicitante</Typography>
                        </Grid>
                        
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                            <TextField label="Nome" variant="outlined" fullWidth disabled value={formData.nome}/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                            <TextField label="Email" variant="outlined" fullWidth disabled value={formData.email} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                            <TextField label="Setor" variant="outlined" fullWidth disabled value={formData.setor} />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <FormControl fullWidth>
                                <InputLabel>Projeto</InputLabel>
                                <Select 
                                    label="Projeto" 
                                    value={formData.projeto} 
                                    onChange={handleProjetoChange}
                                >
                                    {projetos.map((projeto) => (
                                        <MenuItem key={projeto.id} value={projeto.nome}>
                                            {projeto.nome}
                                        </MenuItem>
                                    ))}
                                    <MenuItem value="Outro">Outro</MenuItem>
                                </Select>
                                {isOutroProjeto && (
                                    <TextField
                                        label="Digite o nome do projeto"
                                        variant='outlined'
                                        fullWidth
                                        value={formData.projeto}
                                        onChange={handleProjetoTextChange}
                                        style={{ marginTop: '16px' }}
                                    />
                                )}
                            </FormControl>
                            {errors.projeto && <Typography color="error" variant="caption">{errors.projeto}</Typography>}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <TextField
                            label="Data da solicitação"
                            type="date"
                            defaultValue={getCurrentDate()}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            fullWidth
                            value={formData.data_solicitacao}
                            onChange={(event) => setFormData({ ...formData, data_solicitacao: event.target.value })}
                        />
                        {errors.data_solicitacao && <Typography color="error" variant="caption">{errors.data_solicitacao}</Typography>}
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} marginTop={2}>
                        <Grid item xs={12}>
                            <Typography variant="h6">Informação da amostra</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                            <Typography variant="subtitle1" align="center" fontWeight={700} borderRadius={1} style={{ background: '#FFD54F', color: '#10427F' }}>ID Amostra</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                            <Typography variant="subtitle1" align="center" fontWeight={700} borderRadius={1} style={{ background: '#FFD54F', color: '#10427F' }}>Material</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                            <Typography variant="subtitle1" align="center" fontWeight={700} borderRadius={1} style={{ background: '#FFD54F', color: '#10427F' }}>Análise</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                            <Typography variant="subtitle1" align="center" fontWeight={700} borderRadius={1} style={{ background: '#FFD54F', color: '#10427F' }}>Preparo de Amostra</Typography>
                        </Grid>
                    </Grid>
                    {samples.map((sample, index) => (
                    <Grid container spacing={2} paddingTop={1} key={index}>
                        <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                            <TextField
                                label=""
                                variant="outlined"
                                placeholder={`Ex: Am ${sample.id} - Positiva`}
                                fullWidth
                                value={sample.id_amostra}
                                required
                                onChange={(e) => {
                                    const newSamples = [...samples];
                                    newSamples[index].id_amostra = e.target.value
                                    setSamples(newSamples)
                                }}
                            />
                            {errors.amostras && errors.amostras[index]?.id_amostra && <Typography color="error" variant="caption">{errors.amostras[index].id_amostra}</Typography>}
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>

                        <FormControl fullWidth>
                            <Select
                                required
                                value={sample.material}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    // Verifica se o valor é "Outro"
                                    if (value === "Outro") {
                                        setSamples(prevSamples => {
                                            const newSamples = [...prevSamples];
                                            newSamples[index].material = ""; // Limpa o campo ao selecionar "Outro"
                                            return newSamples;
                                        });

                                        setOutrosSelecionados(prevOutros => {
                                            const newOutros = [...prevOutros];
                                            newOutros[index] = true; // Marca este índice como "Outro"
                                            return newOutros;
                                        });
                                    } else {
                                        setSamples(prevSamples => {
                                            const newSamples = [...prevSamples];
                                            newSamples[index].material = value; // Atualiza o valor selecionado
                                            return newSamples;
                                        });

                                        setOutrosSelecionados(prevOutros => {
                                            const newOutros = [...prevOutros];
                                            newOutros[index] = false; // Marca este índice como não sendo "Outro"
                                            return newOutros;
                                        });
                                    }
                                }}
                            >
                                {materiais.map((material) => (
                                    <MenuItem key={material.id} value={material.nome}>
                                        {material.nome}
                                    </MenuItem>
                                ))}
                                <MenuItem value="Outro">Outro</MenuItem>
                            </Select>

                            {/* Campo de texto visível apenas quando "Outro" for selecionado para este índice */}
                            {outrosSelecionados[index] && (
                                <TextField
                                    required
                                    label="Digite o material"
                                    variant="outlined"
                                    fullWidth
                                    value={sample.material} // O valor digitado vai diretamente para sample.material
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSamples(prevSamples => {
                                            const newSamples = [...prevSamples];
                                            newSamples[index].material = value; // Atualiza o campo com o valor digitado
                                            return newSamples;
                                        });
                                    }}
                                    style={{ marginTop: '16px' }} // Espaçamento para manter a interface limpa
                                />
                            )}
                        </FormControl>
                        {errors.amostras && errors.amostras[index]?.material && <Typography color="error" variant="caption">{errors.amostras[index].material}</Typography>}
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                        <SelectAnalises
                            names={analises}
                            selectedAnalises={sample.analise}
                            onChange={(e: SelectChangeEvent<string[]>) => {
                                const value = e.target.value;

                                // Verifica se o valor é "Outras"
                                if (value.includes("Outras")) {
                                    setSamples(prevSamples => {
                                        const newSamples = [...prevSamples];
                                        newSamples[index].analise = []; // Limpa o campo ao selecionar "Outras"
                                        return newSamples;
                                    });

                                    setOutrasSelecionadas(prevOutras => {
                                        const newOutras = [...prevOutras];
                                        newOutras[index] = true; // Marca este índice como "Outras"
                                        return newOutras;
                                    });
                                } else {
                                    setSamples(prevSamples => {
                                        const newSamples = [...prevSamples];
                                        newSamples[index].analise = Array.isArray(value) ? value : [value]; // Atualiza o valor selecionado
                                        return newSamples;
                                    });

                                    setOutrasSelecionadas(prevOutras => {
                                        const newOutras = [...prevOutras];
                                        newOutras[index] = false; // Marca este índice como não sendo "Outras"
                                        return newOutras;
                                    });
                                }

                                const newSamples = [...samples];
                                newSamples[index].analise = typeof value === 'string' ? value.split(',') : value;
                                setSamples(newSamples);
                            }}
                        />
                        {outrasSelecionadas[index] && (
                            <TextField
                                required
                                label="Digite as análises separadas por vírgula"
                                variant="outlined"
                                fullWidth
                                value={sample.analise}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSamples(prevSamples => {
                                        const newSamples = [...prevSamples];
                                        newSamples[index].analise = value.split(','); // Atualiza o campo com o valor digitado
                                        return newSamples;
                                    });
                                }}
                                style={{ marginTop: '16px' }} // Espaçamento para manter a interface limpa
                            />
                        )}
                        {errors.amostras && errors.amostras[index]?.analise && <Typography color="error" variant="caption">{errors.amostras[index].analise}</Typography>}
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                            <TextField
                                required
                                label=""
                                variant="outlined"
                                fullWidth
                                multiline
                                value={sample.preparo}
                                onChange={(e) => {
                                    const newSamples = [...samples];
                                    newSamples[index].preparo = e.target.value
                                    setSamples(newSamples)
                                }}
                            />
                        </Grid>    
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} paddingBottom={3}>
                        <Button variant="text" size="small" onClick={() => handleRemoveSample(index)} style={{ color: '#f44336', borderColor: '#f44336' }}>
                            {/* <RemoveCircle /> */}
                            Remover
                        </Button>
                        </Grid>
                    </Grid>
                    ))}
                    <Grid container spacing={2} paddingTop={1}>
                        <Grid item xs={12} >
                            <Button size="large" variant="outlined" fullWidth onClick={handleAddSample} style={{ color: '#3860B2', borderColor: '#3860B2' }}>
                                <AddCircle />
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} paddingTop={3}>
                        <Grid item xs={12}>
                            <Typography variant="h6">Mais informações</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField label="Objetivo do ensaio" fullWidth multiline name="objetivo" value={formData.objetivo} onChange={handleChange} />
                            {errors.objetivo && <Typography color="error" variant="caption">{errors.objetivo}</Typography>}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <TextField label="Destino pós-teste" fullWidth multiline name="destino" value={formData.destino} onChange={handleChange} />
                            {errors.destino && <Typography color="error" variant="caption">{errors.destino}</Typography>}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <TextField label="Observações" fullWidth multiline name="observacoes" value={formData.observacoes} onChange={handleChange} />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} paddingTop={4} textAlign="right">
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={2}>
                    <input 
                        type="file" 
                        onChange={handleChangeFile} 
                        style={{ display: 'none' }} 
                        id="file-input" 
                    />
                    
                    {/* Botão de Seleção de Arquivo */}
                    <Button 
                        variant="contained" 
                        size="large" 
                        color="primary" 
                        startIcon={<AttachFile />}
                        onClick={() => document.getElementById('file-input')?.click()}
                        style={{ textTransform: 'none', marginTop: 20 }}
                    >
                        Upload de anexo
                    </Button>

                    {/* Mostra o nome do arquivo selecionado */}
                    {file && (
                        <Typography variant="body1" color="textSecondary" marginBottom={4}>
                            Arquivo selecionado: <strong>{file.name}</strong>
                        </Typography>
                    )}

                    {/* Botão de Anexo (desativado agora) */}
                    {/* O anexo será enviado junto com o formulário no botão "Enviar" */}
                </Box>
                        <Button 
                            type="submit" 
                            size="large" 
                            variant="contained" 
                            endIcon={<Send />} 
                            disabled={loadingButton}
                            style={{ background: loadingButton ? '#bdbdbd' : '#3860B2', marginLeft: '20px', marginTop: 20 }}
                        >
                            {loadingButton ? <CircularProgress size={24} color="inherit" /> : 'Enviar'}
                        </Button>
                    </Grid>
                    {/* {submitted && <Typography color="success">Solicitação enviada com sucesso!</Typography>} */}
                </form>
            </Paper>
        </>
    )
}